module.exports = __webpack_public_path__ + "static/BT_underground-4942232d983a79f80b3be9224bca36a2.png";